export const posthogEvents = {
  // #region Account
  account: {
    general: {
      profile: {
        success: 'user_details_edited',
        failure: 'user_details_edit_failed',
      },
    },
    notifications: {
      disabled: 'notifications_all_disabled',
      enabled: 'notifications_all_enabled',

      webPush: {
        notNow: 'web_push_notifications_not_now_clicked',
        disabled: 'web_push_notifications_disabled',
        disablingError: 'web_push_notifications_disabling_error',
        enabled: 'web_push_notifications_enabled',
        enablingError: 'web_push_notifications_enabling_error',
      },
    },
    security: {
      password: {
        success: 'user_password_reset',
        failed: 'user_password_reset_failed',
      },
      twoFactor: {
        disabled: {
          success: 'security_2fa_disabled',
          failed: 'security_2fa_disable_failed',
        },
        enabled: {
          success: 'security_2fa_enabled',
          failed: 'security_2fa_enable_failed',
        },
      },
    },
    billing: {
      invoices: {
        view: 'account_invoices_view',
        bulk: {
          success: 'account_invoices_download_success',
          failed: 'account_invoices_download_failed',
        },
      },
      invoice: {
        view: 'account_invoice_view',
      },
      transactions: {
        view: 'account_transactions_view',
      },
    },
  },
  // #endregion Account

  // #region Auth
  auth: {
    signIn: {
      success: 'user_logged_in',
      failed: 'user_login_failed',
    },
    signUp: {
      failed: 'user_registration_failed',
    },
    signOut: 'user_logged_out',
    oAuth: 'user_login_oauth',
    multiFactor: {
      started: 'user_login_2fa',
      success: 'user_2fa_sign_in_success',
      failed: 'user_2fa_sign_in_failed',
    },
    forgotPassword: {
      success: 'user_forgot_password_success',
      failed: 'user_forgot_password_failed',
    },
  },
  // #endregion Auth

  // #region Common
  common: {
    languageChanged: 'user_language_changed',
    switchedToVPNCheap: 'switched_to_vpn_cheap',
    review: {
      dismiss: 'review_dismiss_clicked',
      leaveReview: 'leave_a_review_clicked',
    },

    offers: {
      mobile: 'offer_mobile_proxies_clicked',
      residential: 'offer_rotating_residential_proxies_clicked',
      referProxy: 'offer_refer_proxies_clicked',
      chromeExtension: 'offer_chrome_extension_clicked',
      firefoxExtension: 'offer_firefox_extension_clicked',
      blackFriday: 'offer_black_friday_clicked',
      valentine: 'offer_valentine_clicked',
      lunar: 'offer_lunar_clicked',
      stPatrick: 'offer_st_patrick_clicked',
      ipv6: {
        datacenter: 'offer_ipv6_datacenter_clicked',
      },
    },
  },
  // #endregion Common

  // #region Dashboard
  dashboard: {
    overview: {
      quickStartGuidesClicked: 'dashboard_overview_quick_start_guides_clicked',
      faqClicked: 'dashboard_overview_faq_clicked',
    },
  },
  // #endregion Dashboard

  // #region Email
  email: {
    confirmation: {
      resent: 'email_confirmation_resent',
      displayed: 'order_email_confirmation_displayed',
    },
  },
  // #endregion Email

  // #region Proxy
  proxy: {
    extendBandwidth: {
      success: 'proxy_bandwidth_extended',
      failed: 'proxy_bandwidth_extend_failed',
      canceled: 'proxy_bandwidth_extend_canceled',
    },
    extendPeriod: {
      success: 'proxy_period_extended',
      failed: 'proxy_period_extend_failed',
      canceled: 'proxy_period_extend_canceled',
    },
    reactivated: {
      success: 'proxy_reactivated',
      failed: 'proxy_reactivated_failed',
    },
    autoExtend: {
      enabled: {
        success: 'proxy_auto_extend_enabled',
        failed: 'proxy_auto_extend_enable_failed',
      },
      disabled: {
        success: 'proxy_auto_extend_disabled',
        failed: 'proxy_auto_extend_disable_failed',
      },
    },
    autoExtendBandwidth: {
      enabled: {
        success: 'proxy_auto_extend_bandwidth_enabled',
        failed: 'proxy_auto_extend_bandwidth_enable_failed',
      },
      disabled: {
        success: 'proxy_auto_extend_bandwidth_disabled',
        failed: 'proxy_auto_extend_bandwidth_disable_failed',
      },
    },
    changeProtocol: {
      success: 'proxy_protocol_changed',
      failed: 'proxy_protocol_change_failed',
    },
    copyCredentials: {
      success: 'proxy_credentials_copy',
      failed: 'proxy_credentials_copy_failed',
    },
    downloadCredentials: {
      success: 'proxy_credentials_download',
      failed: 'proxy_credentials_download_failed',
    },
    globalIPWhitelist: {
      success: 'proxy_globalIpWhitelist_modified',
      failed: 'proxy_globalIpWhitelist_modify_failed',
    },
    regenerateCredentials: {
      success: 'proxy_credentials_regenerated',
      failed: 'proxy_credentials_regeneration_failed',
    },
    rotateIp: {
      success: 'proxy_ip_rotated',
      failed: 'proxy_ip_rotation_failed',
    },
    upgradeBandwidthSpeed: {
      success: 'proxy_upgrade_bandwidth_speed',
      failed: 'proxy_upgrade_bandwidth_speed_failed',
    },
    upgradeThreads: {
      success: 'proxy_upgrade_threads',
      failed: 'proxy_upgrade_threads_failed',
    },
    authenticationType: {
      success: 'proxy_authentication_type_modified',
      failed: 'proxy_authentication_type_modify_failed',
    },
    port: {
      success: 'proxy_port_changed',
      failed: 'proxy_port_change_failed',
    },
    bulk: {
      extendBandwidth: {
        success: 'proxy_bandwidth_extended_bulk',
        failed: 'proxy_bandwidth_extend_bulk_failed',
        canceled: 'proxy_bandwidth_extend_bulk_canceled',
      },
      extendPeriod: {
        success: 'proxy_period_extended_bulk',
        failed: 'proxy_period_extend_bulk_failed',
        canceled: 'proxy_period_extend_bulk_canceled',
      },
      autoExtend: {
        success: 'proxy_auto_extend_bulk',
        failed: 'proxy_auto_extend_bulk_failed',
      },
      changeProtocol: {
        success: 'proxy_protocol_changed_bulk',
        failed: 'proxy_protocol_change_bulk_failed',
      },
      authenticationType: {
        success: 'proxy_authentication_type_modified_bulk',
        failed: 'proxy_authentication_type_modify_bulk_failed',
      },
      reactivated: {
        success: 'proxy_reactivated_bulk',
        failed: 'proxy_reactivated_bulk_failed',
        canceled: 'proxy_reactivated_bulk_canceled',
      },
    },
    actions: {
      details: 'proxy_action_details_click',
      autoExtend: 'proxy_action_auto_extend_click',
      changeAuthenticationMethod: 'proxy_action_change_authentication_method_click',
      changeProtocol: 'proxy_action_change_protocol_click',
      downloadCredentials: 'proxy_action_download_credentials_click',
      extendBandwidth: 'proxy_action_extend_bandwidth_click',
      extendPeriod: 'proxy_action_extend_period_click',
      reactivate: 'proxy_action_reactivate_click',

      orderSimilarProxy: {
        sameSubnetNotAvailable: 'order_similar_proxy_same_subnet_not_available',
        subnet: 'order_similar_proxy_subnet_clicked',
        settings: 'order_similar_proxy_settings_clicked',
      },
    },
    copyCommand: 'proxy_overview_cli_command_copied',
    testProxy: {
      success: 'proxy_test_success',
      failure: 'proxy_test_failure',
    },

    credentialsGenerator: {
      generated: 'proxy_credentials_generated',
    },

    replacement: {
      proxyReplacementInitiated: 'proxy_replacement_initiated',
      proxyReplacementSuccess: 'proxy_replacement_success',
      proxyReplacementFailure: 'proxy_replaced_failure',
    },

    howToConnect: {
      chrome: 'proxy_how_to_connect_chrome_clicked',
      firefox: 'proxy_how_to_connect_firefox_clicked',
      'vpn-cheap': 'proxy_how_to_connect_vpn_cheap_clicked',
    },

    purchased: 'proxy_purchased',
  },
  // #endregion Proxy

  // #region Marketplace
  marketplace: {
    dealSelected: 'marketplace_deal_selected',
  },
  // #endregion Marketplace

  // #region Order flow
  order: {
    testIPv6Clicked: 'order_test_ipv6_clicked',

    countryRequest: {
      success: 'order_country_request_success',
      failure: 'order_country_request_failure',
    },

    v2: {
      started: 'order_v2_started',
      exit: 'order_v2_exit',
      outOfStock: 'order_v2_out_of_stock',
      numberOfTrialProxiesExceeded: 'order_v2_trial_exceeded',

      couponCode: {
        applied: 'order_v2_coupon_code_applied',
        invalid: 'order_v2_coupon_code_invalid',
      },

      personalDetails: {
        skipped: 'order_v2_user_details_skipped',
        filled: 'order_v2_user_details_filled',
        failed: 'order_v2_user_details_failed',

        country: {
          filled: 'order_v2_user_details_country_filled',
          failed: 'order_v2_user_details_country_failed',
        },
      },

      checkout: {
        executed: 'order_v2_executed',
        failure: 'order_v2_failure',
        initiated: 'order_v2_checkout_initiated',
        paymentChosen: 'order_v2_checkout_payment_chosen',
      },

      vpn: 'order_v2_vpn_clicked',

      serviceSelected: 'order_v2_service_selected',
      planSelected: 'order_v2_plan_selected',
      countrySelected: 'order_v2_country_selected',
      regionSelected: 'order_v2_region_selected',
      citySelected: 'order_v2_city_selected',
      ispSelected: 'order_v2_isp_selected',
      periodSelected: 'order_v2_period_selected',
      packageSelected: 'order_v2_package_selected',
      quantitySelected: 'order_v2_quantity_selected',
      trafficSelected: 'order_v2_traffic_selected',
      additionalTrafficSelected: 'order_v2_additional_traffic_selected',

      specialOfferSelected: 'order_v2_special_offer_selected',
      learnMoreClicked: 'order_v2_learn_more_clicked',

      setupCompleted: 'order_v2_setup_completed',
    },
  },
  // #endregion Order flow

  // #region Referrals
  referrals: {
    link: 'link_copied',
    code: {
      banner: 'banner_code_copied',
      widget: 'widget_code_copied',
    },
    payout: {
      clicked: 'payout_clicked',
      failure: 'payout_failure',
      submitted: 'payout_submitted',
    },
  },
  // #endregion Referrals

  // #region Organizations
  organizations: {
    create: {
      started: 'organization_create_started',
      success: 'organization_created',
      failed: 'organization_create_failed',
    },
    switcher: {
      opened: 'organization_switcher_opened',
      switched: 'organization_switched',
      createClicked: 'organization_switcher_create_clicked',
      settingsClicked: 'organization_switcher_settings_clicked',
    },
    manage: {
      visited: 'organization_manage_visited',
    },
    member: {
      add: {
        opened: 'organization_member_add_opened',
        success: 'organization_member_added',
        failed: 'organization_member_add_failed',
        alreadyMember: 'organization_member_add_already_member',
        alreadyPending: 'organization_member_add_already_pending',
      },
      remove: {
        opened: 'organization_member_remove_opened',
        success: 'organization_member_removed',
        failed: 'organization_member_remove_failed',
      },
    },
    settings: {
      companyDetails: {
        success: 'organization_company_details_updated',
        failed: 'organization_company_details_update_failed',
      },
    },
    guards: {
      adminRedirected: 'organization_admin_guard_redirected',
      permissionDenied: 'organization_permission_denied',
    },
  },
  // #endregion Organizations

  // #region TopUp
  orderTopUp: {
    click: 'order_topup_click',
    formSubmitted: 'order_topup_form_submitted',
    success: 'order_topup_success',
    failure: 'order_topup_failure',
    canceled: 'order_topup_canceled',
  },

  topUp: {
    click: 'topup_click',
    formSubmitted: 'topup_form_submitted',
    success: 'topup_success',
    failure: 'topup_failure',
    canceled: 'topup_canceled',
  },

  organizationTopUp: {
    click: 'organization_topup_click',
    formSubmitted: 'organization_topup_form_submitted',
    success: 'organization_topup_success',
    failure: 'organization_topup_failure',
    canceled: 'organization_topup_canceled',
  },
  // #endregion TopUp

  // #region Performance
  performance: {
    webVitals: 'web_vitals_measured',
  },
  // #endregion Performance
};
